// extracted by mini-css-extract-plugin
export default {"NoPermissionContainer":"noPermission_NoPermissionContainer__-9WuP","iconWrapper":"noPermission_iconWrapper__yNhrj"};